import React from "react";

export default function SegmentedTabs({
    items = [],
    value,
    onChange,
    ariaLabel = "Sections",
    collapseToSelect = false,
    selectLabel = "Section",
    className = "",
}) {
    const handleKeyDown = (event, index) => {
        const lastIndex = items.length - 1;
        let nextIndex = null;

        if (event.key === "ArrowRight") nextIndex = index === lastIndex ? 0 : index + 1;
        if (event.key === "ArrowLeft") nextIndex = index === 0 ? lastIndex : index - 1;
        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = lastIndex;
        if (nextIndex === null) return;

        event.preventDefault();
        while (items[nextIndex]?.disabled && nextIndex !== index) {
            nextIndex = event.key === "ArrowLeft"
                ? (nextIndex === 0 ? lastIndex : nextIndex - 1)
                : (nextIndex === lastIndex ? 0 : nextIndex + 1);
        }
        if (items[nextIndex]?.disabled) return;

        onChange(items[nextIndex].id);
        event.currentTarget.parentElement
            ?.querySelectorAll('[role="tab"]')
            ?.[nextIndex]
            ?.focus();
    };

    const rootClassName = [
        "segmented-tabs-control",
        collapseToSelect ? "segmented-tabs-control--responsive" : "",
        className,
    ].filter(Boolean).join(" ");

    return (
        <div className={rootClassName}>
            <div className="segmented-tabs" role="tablist" aria-label={ariaLabel}>
                {items.map((item, index) => (
                    <button
                        key={item.id}
                        type="button"
                        role="tab"
                        id={item.tabId}
                        aria-selected={value === item.id}
                        aria-controls={item.controls}
                        tabIndex={value === item.id ? 0 : -1}
                        className={`segmented-tabs__button${value === item.id ? " segmented-tabs__button--active" : ""}`}
                        onClick={() => onChange(item.id)}
                        onKeyDown={(event) => handleKeyDown(event, index)}
                        disabled={item.disabled}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
            {collapseToSelect && (
                <label className="segmented-tabs-select">
                    <span className="form-field__label">{selectLabel}</span>
                    <select
                        className="form-field__select"
                        value={value}
                        onChange={(event) => onChange(event.target.value)}
                        aria-label={selectLabel}
                    >
                        {items.map((item) => (
                            <option key={item.id} value={item.id} disabled={item.disabled}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                </label>
            )}
        </div>
    );
}
